import { Injectable } from "@angular/core";
import { rate, draft, fullModel, quickQuote, CompanyCode, CompanyName, effectiveDate, expirationDate, auditFrequency, underwriterCode, BusinessName, InsuredType, yearsOfOperation, City, Line1, StateCode, StateDesc, ZipCode, ContactName, Phone1, ProducerCode, producerOfRecord, EMail, primaryState, liabMedicalExpensLmt, prodCompleteOperAggLmt, liabMedicalExpAggLmt, medicalExpensPerPerson, liabilityDeduApp, blanketRating, equipmentBreakdown, cEmpPracLiab, cEpliLimDed, cDoesLocMtf, CNoEmpMore, CNoEmpLess, cIsCyberCov, cCyberOption, cCyberCovLimit, CBlgExtRepCc, CExtRpCcOptions, fuelTank, enhancerEndorsement, cEnhancerPlusEndt, selfStorgFacilEnd, residCleanServCovAp, employeeDishonesty, electronicData, forgeryOrAlteration, interruptionCompOper, businessIncome, hireNonownAutoLiab, hireNonownAutoLiabCov, hireAutoNonownLiabType, hiredAutoLiabLimit, nonownedAutoLiabLmt, nonOwnedAutoLiabCov, compAndFundTranFrd, moldFungiWetDryRot, apartLosDamCusAuto, resLossDamCustAuto, contractorsEndorsement, terrorismCoverage, leadPoisoning, wantGenQstn, referenceObjectId, copyMailingAddress, description, incLmtFireDeptSc, outdoorSigns, moneyAndSecurity, empDishonestyApp, moldFungWetDryRtAp, wtrBckupSmpOvrfl, apartBuildCov, apartBldFineArtsCov, apartLosDamCusApp, apartBldLossDamLmt, apartmentBldEnd, restaurantsCov, resLosDamCusAutoAp, restEndorsement, locationId, BldgPropertyType, PropertyType, RentalProperty, BuildingSquareFootage, ConstructionType, NumberOfEmployees, DistanceFromFireStation, DistToNearestHydrant, PublicProtFireClas, Interest, OwnerOccupiedSqFtge, cRatingBasis, YearBuilt, NumberOfUnits, NumberOccupiedByOwners, NumberLeasedToOthers, NumberVacant, IsThereABasement, PercentFinished, BldReplacementCostEst, cReconstrConstr, ResAuRepMnufcProcOcup, bldHaveAFireAlarm, fireAlarmALocalAlarm, fireAlarmACenStnAlarm, fireAlarmAHrdwrSmkDet, fireAlarmABatopSmkDet, cBurgAlarm, cBurglarLocal, cBurgCentral, bldAnyOtherProtection, BldDeadboltDoorLocks, NoOfUnitsLetterCntrl, LeadPoisonYrConst, supplLeadPoisonAppl, fuelTankApplies, dmgPremisesRentYou, dmgPremRentYouSelCov, dmgPremRentYouLimit, swimmingPool, cBusinessIncExcl, offPrmBsnsInter, windstormOrHailExcl, optionalBldgDedu, OptionalPropertyDedu, windstrmHailPrcntDed, autoIncInInsurance, spoilage, comCondUntOwner, condominComUntOwnr, lossAssessmentLmt, MiscRealPropertyLmt, lossAssessmentDed, LossAssmntSubltForDed, foodContamination, timeElement, directDamage, vacancyPermitEndors, lossPayableClauses, earthquakeCoverage, BldOwnrAndSoleOccupant, BuildingLimitInsurance, includedBlanketRating, incRebudExpFollDis, greenUpgrades, ordinanceLaw, whRoofSurfaceLoss, ltCovAcvBldRc, debrisRemAddInsEndt, ClassCode, BusinssPersonalPropLmt, AreaOccupied, ClassificationPercen, cTenanatRelExp, utlSrvcDirectDmgApp, electronicDataCovApp, intOfCompOprCovApp, incLmtAccountsRecv, incLmtDpndntProp, incLmtPaperRecord, incLmtOutdoorProp, specBppTmpAwayFrmPrm, theftLimitations, brandsAndLabels, permYardsMaintainStr, seasonalIncPercentage, spoilageCovApp, earthquakeCovApplies, condDirctLiabEndt, medExpensExclusion, Endorsement, BusinessDesc, otherLocations, CSelectSubmission, cCompPolicy, namePriorInsurer, PriorInsPremium, ListOfPolicies, recentPolCancld, cReasons, cancelExplanation, YrsExpClass, ContractorResg, snowIceRemoval, privateDriveways, parkingLots, roadHighways, OwnerPartner, EmployeePayroll, TemporaryWorker, totalPayroll, UiSubcontractorPay, GlCertSubcntrsPay, applicantSubcontract, applicantLawsuit, remarkTradeContractors, InsuredConst, ProducerConst, ContactConst, AddressConst, BusinessOwnersConst, BPLocationsConst, BPInlineOBJConst, BPBuildingConst, BPBuildingCoverageConst, BPClassificationsConst, BPOptionalRTCCoveragesConst, BPGeneralQuestionsMUConst, BPCompanionPolicy, CCompPolicyType, CCompPolicyNumberRef, IndRiskPremiumMod, cusGoodsLegalLiabLmt, name, CCoastalZone, cSmallContractor, businessPersonalProp, building, autoSprinkleredSystem, cRoof, cElectrical, cWaterHeater, cHeating, cPlumbing, leadPoisoningAppl, maintenanceFees, brbBeutPrsEnhPrfLb, professionalClass, noOfFullTimeBarbers, noOfPartTimeBarbers, noOfFlTmBuPrEnPf, noOfPtTmBuPrEnPf, photography, BPIRPMRating, ProvideBreak, BPIRPMRatingLevel, FactorType, OverrideModifier, OverrideReason, StateName, TotalModifier, LosseHistory, DefaultValue, MaxValue, MinValue, CExtendednamedinsured1, Extendednamedinsured1, BPLossHistoryGeneralQuestionsConst, CrmProtAlmACenStAlm, CrmProtAlmALocalAlm, IrpmCovUk, BPIRPMOverridefactors, UnderwriterRiskConcern, RiskFactor, OverrideValue, classificationDesc } from "@app/contractor.constant";
import { ProcessingRequest } from "@app/interfaces/others/processing.modal";

@Injectable({
  providedIn: "root",
})
export class ProcessingDataService {
  constructor() {}

  processingData: ProcessingRequest = {
    [rate]: "Y",
    [draft]: "N",
    [fullModel]: "Y",
    [quickQuote]: "N",
    quotePolicy: {
      [CompanyCode]: "80",
      [CompanyName]: "MAPFRE Insurance Company",
      [effectiveDate]: "",
      [expirationDate]: "",
      [auditFrequency]: "Non-Auditable",
      [underwriterCode]: "",
      [InsuredConst]: {
        [BusinessName]: "",
        [InsuredType]: "",
        [yearsOfOperation]: "",
        [AddressConst]: {
          [City]: "",
          [Line1]: "",
          [StateCode]: "",
          [StateDesc]: "",
          [ZipCode]: "",
        },
        [ContactConst]: {
          [ContactName]: "",
          [Phone1]: "",
          [EMail]: "",
        },
        [Extendednamedinsured1]: {
          [CExtendednamedinsured1]: ""
        }
      },
      [ProducerConst]: {
        [ProducerCode]: "",
        [producerOfRecord]: "",
        [ContactConst]: {
          [ContactName]: "",
          [EMail]: "",
          [Phone1]: "",
        },
      },
      [BusinessOwnersConst]: {
        [primaryState]: "Massachusetts",
        [liabMedicalExpensLmt]: "1000000",
        [prodCompleteOperAggLmt]: "2000000",
        [liabMedicalExpAggLmt]: "2000000",
        [medicalExpensPerPerson]: "5000",
        [liabilityDeduApp]: "N",
        [blanketRating]: "N",
        [IndRiskPremiumMod]: "Y", // default value
        [equipmentBreakdown]: "",
        [cEmpPracLiab]: "Y",
        [cEpliLimDed]: "25000",
        [cDoesLocMtf]: "N",
        [CNoEmpMore]: "",
        [CNoEmpLess]: "",
        [cIsCyberCov]: "",
        [cCyberOption]: "",
        [cCyberCovLimit]: "",
        [CBlgExtRepCc]: "",
        [CExtRpCcOptions]: "",
        [fuelTank]: "N",
        [enhancerEndorsement]: "Y",
        [cEnhancerPlusEndt]: "",
        [selfStorgFacilEnd]: "N",
        [cusGoodsLegalLiabLmt]: "50000",
        [residCleanServCovAp]: "N",
        [employeeDishonesty]: "N",
        [electronicData]: "N",
        [forgeryOrAlteration]: "N",
        [interruptionCompOper]: "N",
        [businessIncome]: "N",
        [hireNonownAutoLiab]: "",
        [hireNonownAutoLiabCov]: "",
        [hireAutoNonownLiabType]: "Both",
        [hiredAutoLiabLimit]: "",
        [nonownedAutoLiabLmt]: "",
        [nonOwnedAutoLiabCov]: "",
        [compAndFundTranFrd]: "N",
        [moldFungiWetDryRot]: "N",
        [apartLosDamCusAuto]: "N",
        [resLossDamCustAuto]: "N",
        [contractorsEndorsement]: "N",
        [terrorismCoverage]: "Y",
        [leadPoisoning]: "N",
        [wantGenQstn]: "Y",
        [BPLocationsConst]: [{
          [referenceObjectId]: "1",
          [copyMailingAddress]: "",
          [name]: "",
          [description]: "",
          [AddressConst]: {
            [CCoastalZone]: "",
            [cSmallContractor]: "",
            [City]: "",
            [Line1]: "",
            [StateCode]: "MA",
            [StateDesc]: "Massachusetts",
            [ZipCode]: "",
          },
          [BPInlineOBJConst]: {
            [incLmtFireDeptSc]: "N",
            [outdoorSigns]: "N",
            [moneyAndSecurity]: "N",
            [empDishonestyApp]: "N",
            [moldFungWetDryRtAp]: "N",
            [wtrBckupSmpOvrfl]: "N",
            [apartBuildCov]: "N",
            [apartBldFineArtsCov]: "",
            [apartLosDamCusApp]: "",
            [apartBldLossDamLmt]: "",
            [apartmentBldEnd]: "",
            [restaurantsCov]: "N",
            [resLosDamCusAutoAp]: "N",
            [restEndorsement]: "N",
          },
        }],
        [BPBuildingConst]: [{
          [locationId]: "1",
          [businessPersonalProp]: "",
          [building]: "Y",
          [BldgPropertyType]: "Processing and Service Risks",
          [PropertyType]: "Processing and Service Risks",
          [RentalProperty]: "",
          [BuildingSquareFootage]: "",
          [ConstructionType]: "",
          [NumberOfEmployees]: "0",
          [DistanceFromFireStation]: "",
          [DistToNearestHydrant]: "",
          [PublicProtFireClas]: "",
          [autoSprinkleredSystem]: "",
          [Interest]: "",
          [OwnerOccupiedSqFtge]: "",
          [cRatingBasis]: "",
          [YearBuilt]: "",
          [cRoof]: "",
          [cElectrical]: "",
          [cWaterHeater]: "",
          [cHeating]: "",
          [cPlumbing]: "",
          [NumberOfUnits]: "",
          [NumberOccupiedByOwners]: "",
          [NumberLeasedToOthers]: "",
          [NumberVacant]: "",
          [IsThereABasement]: "N",
          [PercentFinished]: "",
          [BldReplacementCostEst]: "",
          [cReconstrConstr]: "",
          [ResAuRepMnufcProcOcup]: "N",
          [bldHaveAFireAlarm]: "Y",
          [fireAlarmALocalAlarm]: "",
          [fireAlarmACenStnAlarm]: "",
          [fireAlarmAHrdwrSmkDet]: "",
          [fireAlarmABatopSmkDet]: "",
          [cBurgAlarm]: "",
          [CrmProtAlmALocalAlm]: "",
          [CrmProtAlmACenStAlm]: "",
          [bldAnyOtherProtection]: "N/A",
          [BldDeadboltDoorLocks]: "Y",
          [leadPoisoningAppl]: "",
          [NoOfUnitsLetterCntrl]: "0",
          [LeadPoisonYrConst]: "After 1978",
          [supplLeadPoisonAppl]: "",
          [fuelTankApplies]: "N",
          [dmgPremisesRentYou]: "Y",
          [dmgPremRentYouSelCov]: "Basic",
          [dmgPremRentYouLimit]: "50000",
          [swimmingPool]: "N",
          [cBusinessIncExcl]: "N",
          [offPrmBsnsInter]: "N",
          [windstormOrHailExcl]: "N",
          [optionalBldgDedu]: "Y",
          [OptionalPropertyDedu]: "500",
          [windstrmHailPrcntDed]: "N/A",
          [autoIncInInsurance]: "",
          [spoilage]: "N",
          [comCondUntOwner]: "",
          [condominComUntOwnr]: "",
          [lossAssessmentLmt]: "10000",
          [MiscRealPropertyLmt]: "5000",
          [lossAssessmentDed]: "500",
          [LossAssmntSubltForDed]: "1050",
          [foodContamination]: "N",
          [timeElement]: "N",
          [directDamage]: "N",
          [vacancyPermitEndors]: "N",
          [lossPayableClauses]: "N",
          [earthquakeCoverage]: "N",
          [BldOwnrAndSoleOccupant]: "N",
          [BPBuildingCoverageConst]: {
            [BuildingLimitInsurance]: "",
            [includedBlanketRating]: "N",
            [incRebudExpFollDis]: "N",
            [greenUpgrades]: "N",
            [ordinanceLaw]: "N",
            [whRoofSurfaceLoss]: "N",
            [ltCovAcvBldRc]: "N",
            [debrisRemAddInsEndt]: "N",
          },
          [BPClassificationsConst]: {
            [ClassCode]: "",
            [classificationDesc]:"",
            [BusinssPersonalPropLmt]: "",
            [AreaOccupied]: "Percentage",
            [ClassificationPercen]: "100",
            [cTenanatRelExp]: "N",
            [includedBlanketRating]: "N",
            [maintenanceFees]: "N",
            [greenUpgrades]: "N",
            [utlSrvcDirectDmgApp]: "N",
            [electronicDataCovApp]: "N",
            [intOfCompOprCovApp]: "N",
            [incLmtAccountsRecv]: "N",
            [incLmtDpndntProp]: "N",
            [incLmtPaperRecord]: "N",
            [incLmtOutdoorProp]: "N",
            [specBppTmpAwayFrmPrm]: "N",
            [theftLimitations]: "N",
            [brandsAndLabels]: "N",
            [permYardsMaintainStr]: "N",
            [seasonalIncPercentage]: "25",
            [spoilageCovApp]: "N",
            [earthquakeCovApplies]: "N",
            [condDirctLiabEndt]: "",
            [medExpensExclusion]: "N",
            [brbBeutPrsEnhPrfLb]: "Y",
            [professionalClass]: "",
            [noOfFullTimeBarbers]: "",
            [noOfPartTimeBarbers]: "",
            [noOfFlTmBuPrEnPf]: "",
            [noOfPtTmBuPrEnPf]: "",
            [photography]: "",
          },
        }],
        [BPOptionalRTCCoveragesConst]: [
        ],
        [BPIRPMRating]: [
          {
            [ProvideBreak]: "Y", // backend default
            [StateName]: "Massachusetts", // backend default
            [BPIRPMRatingLevel]: [
              {
                [FactorType]: "Both Combined", // backend default
                [IrpmCovUk]: "MA-Both Combined-Both Combined", // backend default
                [OverrideModifier]: "",
                [TotalModifier]: "",
              },
            ],
            [BPIRPMOverridefactors]: [
              {
                [FactorType]: "", //backend default
                [UnderwriterRiskConcern]: "",
                [RiskFactor]: "",
                [OverrideReason]: "",
                [OverrideValue]: "",
                [TotalModifier]: "",
              }
            ],
          },
        ],
        [BPGeneralQuestionsMUConst]: {
          [BusinessDesc]: "",
          [otherLocations]: "",
          [CSelectSubmission]: "New Business Policy to MAPFRE",
          [BPCompanionPolicy]: {
            [CCompPolicyType]: "",
            [CCompPolicyNumberRef]: "",
          },
          [cCompPolicy]: "N",
          [namePriorInsurer]: "Other",
          [PriorInsPremium]: "0",
          [ListOfPolicies]: "",
          [recentPolCancld]: "",
          [cReasons]: "",
          [cancelExplanation]: "",
          [YrsExpClass]: "",
          [LosseHistory]: "",
          [ContractorResg]: "123456",
          [snowIceRemoval]: "N",
          [privateDriveways]: "N",
          [parkingLots]: "N",
          [roadHighways]: "N",
          [OwnerPartner]: "28600",
          [EmployeePayroll]: "",
          [TemporaryWorker]: "",
          [totalPayroll]: "",
          [UiSubcontractorPay]: "",
          [GlCertSubcntrsPay]: "",
          [applicantSubcontract]: "",
          [applicantLawsuit]: "",
          [remarkTradeContractors]: "",
          [BPLossHistoryGeneralQuestionsConst]: [],
        },
      },
    },
  };
}
